import React, { useContext, useState } from 'react'
import Button from '../../ui/Button/Button'
import { createForm } from '../../utils/newforms/createForm'
import FormRender from '../../utils/newforms/render/FormRender'
import isFormValid from '../../utils/newforms/validation/isFormValid'
import getFormValues from '../../utils/newforms/getFormValues'
import getFieldRenderObject from '../../utils/newforms/render/getFieldRenderObject'
import StatusMessage, { useStatusMessage } from '../../ui/StatusMessage/StatusMessage'
import './Auth.sass'
import defaultSectionStyles from '../../styles/defaultSection.module.scss'
import { firebase } from '../../config/firebase'
import { withRouter } from 'react-router'
import handleSignInErrors from './functions/handleSignInErrors'
import { AuthContext } from '../../App'
import Home from '../Home/Home'
import BlogUiDemo from '../../components/Blog/BlogUiDemo'
import OfflineRegistration, { OfflineBrand } from '../../components/OfflineRegistration/OfflineRegistration'
import { OFFLINE_REGISTRATION_PATH } from '../../config/offlineRegistrationAccess'
import AuthTextField from '../../components/OfflineRegistration/storefront/components/AuthTextField'
import fieldChangedHandler from '../../utils/newforms/changed/fieldChangedHandler'
import offlineFormStyles from '../../components/OfflineRegistration/storefront/AuthRegistration.module.scss'

function Auth({ ...router }) {
  const { user, cities } = useContext(AuthContext)
  const offlineRoute = router.location.pathname.replace(/\/+$/, '') === OFFLINE_REGISTRATION_PATH
  const [form, setForm] = useState(
    createForm({
      formPattern: {
        email: {
          field: {
            fieldId: 'email',
            fieldType: 'input',
            inputType: 'email',
            validationPattern: 'email',
            label: 'E-mail',
            required: true,
          },
          render: getFieldRenderObject(),
        },
        password: {
          field: {
            fieldId: 'password',
            fieldType: 'input',
            inputType: 'password',
            label: 'Пароль',
            required: true,
          },
          render: getFieldRenderObject(),
        },
      },
    })
  )
  const [isLoading, setIsLoading] = useState(false)
  const [showErrors, setShowErrors] = useState(false)
  const [statusMessage, setStatusMessage] = useStatusMessage()

  const onSubmit = (e) => {
    e.preventDefault()

    if (!isFormValid({ form })) {
      setStatusMessage({
        show: true,
        type: 'fail',
        message: "Будь ласка, заповніть обов'язкові поля",
        closeAfter: 5000,
      })
      return setShowErrors(true)
    }
    setShowErrors(false)
    setIsLoading(true)

    const { email, password } = getFormValues({ form })
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => router.history.push(offlineRoute ? OFFLINE_REGISTRATION_PATH : '/'))
      .catch((e) => {
        const errorMessage = handleSignInErrors({ code: e.code })
        if (errorMessage) {
          setStatusMessage({
            show: true,
            type: 'fail',
            message: errorMessage,
            closeAfter: 5000,
          })
        }
        setIsLoading(false)
      })
  }

  return process.env.NODE_ENV === 'development' && `${router.location.pathname}`.startsWith('/blog-ui-demo') ? (
    <BlogUiDemo />
  ) : user && offlineRoute ? (
    <OfflineRegistration />
  ) : user && cities ? (
    <Home />
  ) : (
    <section className={`Auth ${defaultSectionStyles.defaultSection}${offlineRoute ? ' offline-auth' : ''}`}>
      {offlineRoute && (
        <header className="offline-header">
          <div className="offline-container offline-header-inner">
            <OfflineBrand />
            <span className="offline-eyebrow">РОБОЧИЙ ПРОСТІР МАГАЗИНУ</span>
          </div>
        </header>
      )}
      <form onSubmit={onSubmit} className="AuthForm" noValidate={offlineRoute}>
        <h4>Авторизація</h4>
        {statusMessage.show && (
          <StatusMessage className="Site-StatusMessage" type={statusMessage.type} message={statusMessage.message} />
        )}
        {offlineRoute ? (
          <div className={offlineFormStyles.screen}>
            {[
              ['email', 'E-mail', 'email', 'username'],
              ['password', 'Пароль', 'password', 'current-password'],
            ].map(([key, label, type, autoComplete]) => (
              <AuthTextField
                key={key}
                id={`offline-login-${key}`}
                label={label}
                type={type}
                value={form[key].value}
                onChange={(value) => fieldChangedHandler({ fieldIdentifier: key, setForm })({ target: { value } })}
                autoComplete={autoComplete}
                inputMode={key === 'email' ? 'email' : undefined}
                error={showErrors && !form[key].valid ? form[key].error : null}
                disabled={isLoading}
                required
              />
            ))}
          </div>
        ) : (
          <FormRender
            sections={[{ fields: ['email', 'password'] }]}
            form={form}
            setForm={setForm}
            errors={showErrors}
          />
        )}
        <div className="AuthForm-Buttons">
          {offlineRoute ? (
            <button className="offline-button offline-button-primary" type="submit" disabled={isLoading}>
              {isLoading ? 'Входимо…' : 'Увійти'}
            </button>
          ) : (
            <Button
              type="submit"
              title="Увійти"
              theme="solid"
              fill="black"
              icon="long-arrow-right"
              iconPosition="right"
              size={48}
              isLoading={isLoading}
              onClick={onSubmit}
            />
          )}
        </div>
      </form>
    </section>
  )
}

export default withRouter(Auth)
